import { Timer } from 'three/webgpu'
import WebGPUContext from './WebGPUContext'
import MainScene from '../scenes/MainScene'
import Composer from '../postprocessing/Composer'
import Studio from '../debug/Studio'

class Three {
	constructor(container) {
		if (Three.instance) return Three.instance

		this.container = container
		this.isRunning = false
		this.timer = new Timer()
		this.timer.connect(document)

		Three.instance = this
	}

	async run() {
		this.context = new WebGPUContext(this.container)
		await this.context.init()

		const { width, height } = this.context.fullScreenDimensions

		this.studio = new Studio({ enabled: false })
		this.scene = new MainScene(this.context.renderer, { sheet: this.studio.sheet, project: this.studio.project })
		this.scene.init(width, height)

		this.composer = new Composer(this.context.renderer, this.scene, this.scene.camera)

		this.#addResizeListener()
		this.start()

		await this.studio.init()
	}

	start() {
		if (this.isRunning || !this.context.renderer) return

		this.isRunning = true
		this.context.renderer.setAnimationLoop(time => this.#tick(time))
	}

	stop() {
		if (!this.isRunning) return

		this.isRunning = false
		this.context.renderer.setAnimationLoop(null)
	}

	#tick(time) {
		this.timer.update(time)

		this.scene.update(this.timer.getDelta(), this.timer.getElapsed())
		this.composer.render()
	}

	async onPageChange(page) {
		await this.scene.onPageChange(page)
		this.#onResize()
	}

	#addResizeListener() {
		this._onResize = () => this.#onResize()
		window.addEventListener('resize', this._onResize)
	}

	#onResize() {
		const { width, height } = this.context.getFullScreenDimensions()

		this.context.onResize(width, height)
		this.scene.onResize(width, height)
	}

	dispose() {
		this.stop()
		this.timer.dispose()
		window.removeEventListener('resize', this._onResize)
		this.studio.dispose()
		this.composer.dispose()
		this.scene.dispose()
		this.context.dispose()
		Three.instance = null
	}
}

export default Three
